module.exports = __webpack_public_path__ + "static/img/bg0.853c1e6.png";